import { apiURL } from "config/constants";
import { useContextController } from "context";
import { useEffect } from "react";
import { parseIncidentDocs, setIncidentDocsState } from "./feature";

/** Loads the session feature flag. Does not call /api/v1/incidents. */
export default function FeatureFlags() {
  const [{ userData }] = useContextController();

  useEffect(() => {
    if (!userData) {
      setIncidentDocsState("off");
      return;
    }
    let cancelled = false;
    setIncidentDocsState("unknown");
    fetch(`${apiURL}/features`, { credentials: "include", headers: { Accept: "application/json" } })
      .then((response) => response.json())
      .then((json) => {
        if (!cancelled) setIncidentDocsState(parseIncidentDocs(json) ? "on" : "off");
      })
      .catch(() => {
        if (!cancelled) setIncidentDocsState("off");
      });
    return () => {
      cancelled = true;
    };
  }, [userData]);

  return null;
}
